import React, { useEffect, useState } from "react";
import { ReactComponent as NotificationOpen } from "../../../assets/svg/notificationOpen.svg";
import { ReactComponent as NotificationReceived } from "../../../assets/svg/notificationReceived.svg";
import { ReactComponent as Coin } from "../../../assets/svg/coin.svg";
import { Link } from "react-router-dom";
import Select from "react-select";
import "./Header.scss";
import "../../../assets/styles/general/select.scss";
import PopUpNotification from "../../components/PopUpNotification/PopUpNotification";
import { useTranslation } from "react-i18next";
import { useNotification } from "../../../hooks/useNotification";
import { useAuthValidation } from "../../../hooks/useAuthValidation";
import logo from "../../../assets/images/fullLogo.png";

function Header() {
  const { notifications, loading: loadingNotifications } = useNotification();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { i18n, t } = useTranslation();
  const { user, loading: loadingUser } = useAuthValidation();
  const defaultLanguage = "pt-BR";
  const [language, setLanguage] = useState(localStorage.getItem("language") || defaultLanguage);

  const options = [
    { value: "pt-BR", label: "PT" },
    { value: "es", label: "ES" },
    { value: "en", label: "EN" },
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
    localStorage.removeItem("language");
    localStorage.setItem("language", lng);
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
      setLanguage(savedLanguage);
    } else {
      i18n.changeLanguage(defaultLanguage);
      setLanguage(defaultLanguage);
      localStorage.setItem("language", defaultLanguage);
    }
  }, [i18n]);

  // Verifica se há notificações não lidas
  const unreadNotifications = notifications?.some((notification) => !notification.isRead);

  // Funções para abrir/fechar o modal de notificações
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Enquanto carrega as informações do usuário ou as notificações
  if (loadingUser || loadingNotifications) return <header className="header loading-header"></header>;

  if (!user) return null; // Se não houver usuário, retorna nada

  return (
    <header className="header">
      <div className="container row">
        <span>
          {t("header")}, {user.name}
        </span>
        <img src={logo} className="logo" />
        <div className="row">
          <div className="coins row">
            <Coin />
            <span>{user.rewards?.coins || 0}</span>
          </div>
          <div className="notification" onClick={openModal}>
            {unreadNotifications ? <NotificationReceived /> : <NotificationOpen />}
          </div>
          <PopUpNotification isOpen={isModalOpen} closeModal={closeModal} />
          <div className="profile">
            <Link to="/perfil">
              <img src={user.images?.avatar?.link || ""} alt="Imagem de Perfil" />
            </Link>
          </div>
          <Select
            options={options}
            classNamePrefix="select"
            onChange={(selectedOption) => changeLanguage(selectedOption.value)}
            value={options.find((option) => option.value === language)}
          />
        </div>
      </div>
    </header>
  );
}

export default Header;
